import { Icon, IconsEnum, toIconsEnum } from 'components/Icons';
import { useMemo, useState } from 'react';

import { SportResultsAndInfoContent } from 'features/sport/components/sportResultsAndInfoContent';
import { StatisticType } from 'features/sport/utils/betRadar/statisticTypeEnum';
import styles from './BetEventTableRowMobile.module.scss';
import { useGetLabelByKey } from 'hooks/useLingUI';

export type Match = {
  team: string;
  score?: number;
};

export type BetDetails = {
  sport: string | null;
  date: string | null;
  pal: string | null;
  match: string | null;
  score: string | null;
  resultLabel: string | null;
  result: string | null;
  quota: number;
  fissa: number | null;
  status: string | null;
  descriptionStatus: string | null;
  descrizioneSport: string | null;
  idBetradar: number;
  idDisciplina: number;
  verticale?: string | null;
  siglaSport?: string | null;
  palinsesto?: number | null;
  numAvvenimento?: number | null;
  tipologia?: string | null;
  descrizioneCavalli?: string | null;
};

export type BetEventTableRowMobileProps = {
  betDetails: BetDetails;
  onClick?: () => void;
  index?: number;
};

export const BetEventTableRowMobile = ({ betDetails, onClick, index }: BetEventTableRowMobileProps) => {
  const [statsOpen, setStatsOpen] = useState(false);
  const labelFissa = useGetLabelByKey('fixed')!;

  const handleClickStats = () => {
    if (betDetails.verticale && betDetails.verticale.toLowerCase() === 'virtual') {
      window.open(
        `${process.env.NEXT_PUBLIC_SEAMLESS_BASE_URL}/virtuali/statistiche/${betDetails.siglaSport}/${betDetails.palinsesto}/${betDetails.numAvvenimento}`
      );
    } else setStatsOpen(!statsOpen);
  };

  const matches = useMemo(() => {
    const scores = betDetails.score?.split('-');
    const teams = betDetails.match?.split('-');
    if (teams) {
      return teams.map((team, i) => {
        return {
          team: team,
          score: scores?.length === teams.length ? scores[i] : undefined,
        };
      });
    }
    return [];
  }, [betDetails]);

  const disciplina = useMemo(() => `DISCIPLINA_${betDetails.idDisciplina}`, [betDetails]);

  return (
    <div className={styles.container}>
      <div className={`${styles.flex} ${styles.justifyBetween}`}>
        <div>
          <div className={`${styles.flex} ${styles.marginBottom}`}>
            {betDetails.idDisciplina && <Icon iconId={toIconsEnum(disciplina)} className={styles.soccerIcon} />}
            {betDetails.sport && <p className={styles.details}>{betDetails.sport}</p>}
            {betDetails.date && <p className={styles.details}>{betDetails.date}</p>}
          </div>
          <div className={styles.marginBottom}>
            {/* {betDetails.match.map((team, i) => {
              return (
                <div className={styles.flex} key={i}>
                  {!team.score ? null : (
                    <p className={styles.teamScore}>{team.score}</p>
                  )}
                  <p className={styles.team}>{team.team}</p>
                </div>
              );
            })} */}
            {betDetails.descrizioneSport === 'CALCIO' ? (
              matches?.map((team, i) => {
                return (
                  <div className={styles.flex} key={i}>
                    {team.score === null || team.score === undefined ? null : (
                      <p className={styles.teamScore}>{team.score}</p>
                    )}
                    <p className={styles.team}>{team.team}</p>
                  </div>
                );
              })
            ) : (
              <div className={styles.flex}>
                <p className={styles.team}>{betDetails.match}</p>
              </div>
            )}
          </div>
        </div>
        <div>
          <div className={`${styles.flex} ${styles.justifyEnd}`}>
            <p className={styles.details}>{betDetails.pal}</p>
          </div>
          <div className={`${styles.flex} ${styles.marginTop} ${styles.justifyEnd} ${styles.alignCenter}`}>
            {betDetails.status === 'live' || betDetails.status === 'programmata' ? (
              <div className={`${styles.flex} ${styles.alignCenter}`}>
                <Icon iconId={IconsEnum.TV} className={styles.tvIcon} />
              </div>
            ) : null}
            {betDetails.idBetradar && betDetails.idBetradar !== 0 && (
              <button className={styles.buttonIcon} onClick={handleClickStats}>
                {statsOpen ? (
                  <Icon iconId={IconsEnum.CLOSE} className={styles.crossIcon} color="var(--color-primary)" />
                ) : (
                  <Icon iconId={IconsEnum.STATS} className={styles.statsIcon} />
                )}
              </button>
            )}
          </div>
          {betDetails?.tipologia === 'Sistema' && !!betDetails?.fissa && (
            <div className={`${styles.selfEnd} ${styles.checkField}`}>
              <Icon iconId={IconsEnum.CHECK} className={styles.icon} />
              <p>{labelFissa?.toUpperCase()}</p>
            </div>
          )}
        </div>
      </div>

      {/* Quando viene cliccato il bottone delle stats, qui viene visualizzato il componente con il campo di calcio */}
      {statsOpen ? (
        <div className={styles.accordion}>
          <SportResultsAndInfoContent
            id={index}
            type={StatisticType.Avvenimento}
            isOpen
            className={styles.stats}
            providerID={betDetails?.idBetradar!}
          />
        </div>
      ) : null}

      <div className={styles.result}>
        <div>
          <p className={styles.resultLabel}>
            {betDetails.resultLabel}
            {betDetails.descrizioneCavalli && (
              <span className={styles.numeroCavalli}>{` ${betDetails.descrizioneCavalli} `}</span>
            )}
            {': '}
            <span className={styles.resultLabelBold}>{betDetails.result?.toUpperCase()}</span>
          </p>
        </div>
        <div className={`${styles.flex} ${styles.justifyEnd}`}>
          {betDetails.tipologia !== 'Totalizzatore' && betDetails.tipologia !== 'Nazionale' && (
            <p className={styles.resultLabelBold}>{parseFloat(betDetails.quota.toString()).toFixed(2)}</p>
          )}
          <Icon
            iconId={
              betDetails.status === 'Vincente'
                ? IconsEnum.SUCCESS
                : betDetails.status === 'Live'
                ? IconsEnum.MATCH_LIVE
                : betDetails.status === 'Perdente'
                ? IconsEnum.CLOSE_CIRCLE
                : betDetails.status === 'Rimborsato'
                ? IconsEnum.INFO_YELLOW
                : IconsEnum.PROGRAMMED
            }
            className={styles.statusIcon}
            color={
              betDetails.status === 'Vincente'
                ? 'var(--color-success)'
                : betDetails.status === 'Live'
                ? 'var(--color-accent)'
                : betDetails.status === 'Perdente'
                ? 'var(--color-warning)'
                : '#62C5DB'
            }
          />
        </div>
      </div>
    </div>
  );
};
